import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect } from "react";
import { useNavigate } from "react-router";
import RouteLayout from "../../../../Components/Layout/RouteLayout";
import {
  useGetBookingComponentQuery,
  useGetBookingFacilityQuery,
} from "../../../../../api/financeApi";
import { useDispatch, useSelector } from "react-redux";
import {
  GetAllEmployees,
  SubmitBookingService,
} from "../../../../../../utils/redux/HR/HRSlice";
import { toast } from "react-toastify";

const CreateBookingsA = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const employee = useSelector((x) => x?.hr?.all_employees?.result);
  // console.log("employee", employee?.all_employees?.result);
  const [facilityName, setFacilityName] = React.useState("");
  const [employeeName, setEmployeeName] = React.useState("");
  const [optionalComponent, setOptionalComponent] = React.useState([]);
  const [startDate, setStartDate] = React.useState(
    new Date().toISOString().split("T")[0]
  ); // Format date
  const [endDate, setEndDate] = React.useState(
    new Date().toISOString().split("T")[0]
  ); // Format date
  const [additionalNote, setAdditionalNote] = React.useState("");

  const { data: item, isLoading } = useGetBookingFacilityQuery({
    pageSize: 10000,
    pageNumber: 1,
  });
  const { data: facilityData } = useGetBookingComponentQuery({
    pageSize: 10000,
    pageNumber: 1,
    FacilityId: facilityName,
  });

  useEffect(() => {
    dispatch(
      GetAllEmployees({
        pageSize: 100000,
        pageNumber: 1,
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Function to handle form submission
  const handleSubmit = async (event) => {
    event.preventDefault(); // Prevent the default form submission behavior

    const formData = {
      facilityName,
      optionalComponent,
      startDate,
      endDate,
      additionalNote,
    };

    const serviceId = item?.result?.items?.filter(
      (item) => item?.id === facilityName
    );

    const employeeNameDetails = employee?.filter(
      (item) => item?.id === employeeName
    );

    console.log("serviceId", serviceId);
    console.log("employeeNameDetails", employeeNameDetails);

    // return;

    const payload = {
      requisitorId: employeeName,
      requisitorName: `${employeeNameDetails[0]?.firstName} ${employeeNameDetails[0]?.surname}`,
      serviceId: serviceId[0]?.bookingServiceId,
      facilityId: facilityName,
      components: `${optionalComponent}`,
      startDate: startDate,
      endDate: endDate,
      specialRequest: additionalNote,
    };

    try {
      const response = await dispatch(SubmitBookingService(payload));
      console.log("response", response);
      if (response?.payload?.successful === true) {
        // Handle success, maybe navigate or display a success message
        // const data = await response.json();
        // console.log("Booking created successfully:");
        navigate("/dashboard/finance/Book-A-Service"); // Example of navigating to a success page
        toast.success(response?.payload?.statusMessage);
      } else {
        // Handle errors, maybe show an error message
        const errorData = await response.json();
        console.error("Error creating booking:", errorData);
        toast.error(response?.payload?.statusMessage);
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  return (
    <RouteLayout title="Setup">
      <Box sx={{ padding: 4 }}>
        <div className="mb-5">
          <Button
            startIcon={<ArrowBackIcon />}
            variant="outlined"
            style={{ marginRight: "10px" }}
            onClick={() => navigate(-1)}
          >
            Back
          </Button>
        </div>
        <Typography variant="h4" gutterBottom>
          Book a Service
        </Typography>
        <div className="bg-[#fff] shadow-md rounded-md p-10">
          <form onSubmit={handleSubmit}>
            <Grid container spacing={4}>
              <Grid item xs={12} sm={3}>
                <Typography variant="body1" fontWeight="bold">
                  Basic Information
                </Typography>
              </Grid>

              <Grid item xs={12} sm={9}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth required>
                      <InputLabel id="facility-name-label">
                        Facility Name *
                      </InputLabel>
                      <Select
                        labelId="facility-name-label"
                        value={facilityName}
                        onChange={(e) => setFacilityName(e.target.value)}
                      >
                        <MenuItem value="">
                          <em>None</em>
                        </MenuItem>
                        {item?.result?.items?.map((item) => (
                          <MenuItem key={item?.id} value={item?.id}>
                            {item?.facilityName}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth required>
                      <InputLabel id="facility-name-label">
                        Optional Components
                      </InputLabel>
                      <Select
                        labelId="facility-name-label"
                        multiple
                        value={optionalComponent}
                        onChange={(e) => setOptionalComponent(e.target.value)}
                      >
                        <MenuItem value="">
                          <em>None</em>
                        </MenuItem>
                        {facilityData?.result?.items?.map((item) => (
                          <MenuItem key={item?.id} value={item?.id}>
                            {item?.componentName}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth required>
                      <InputLabel id="facility-name-label">
                        Employee Name
                      </InputLabel>
                      <Select
                        labelId="facility-name-label"
                        value={employeeName}
                        onChange={(e) => setEmployeeName(e.target.value)}
                      >
                        <MenuItem value="">
                          <em>None</em>
                        </MenuItem>
                        {employee?.map((item) => (
                          <MenuItem key={item?.id} value={item?.id}>
                            {item?.firstName} {item?.surname}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  {/* Start Date Field */}
                  <Grid item xs={12} sm={6}>
                    <TextField
                      type="datetime-local" // Changed to handle both date and time
                      fullWidth
                      label="Start Date & Time *"
                      value={startDate} // Make sure this is in the format DD/MM/YYYYTHH:MM
                      onChange={(e) => setStartDate(e.target.value)} // Date-time input gives a string in DD/MM/YYYYTHH:MM format
                      InputLabelProps={{
                        shrink: true, // Ensure the label doesn't overlap with the placeholder
                      }}
                    />
                  </Grid>

                  {/* End Date Field */}
                  <Grid item xs={12} sm={6}>
                    <TextField
                      type="datetime-local" // Changed to handle both date and time
                      fullWidth
                      label="End Date & Time *"
                      value={endDate} // Make sure this is in the format DD/MM/YYYYTHH:MM
                      onChange={(e) => setEndDate(e.target.value)} // Date-time input gives a string in DD/MM/YYYYTHH:MM format
                      InputLabelProps={{
                        shrink: true, // Ensure the label doesn't overlap with the placeholder
                      }}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Additional Note"
                      multiline
                      rows={4}
                      placeholder=""
                      value={additionalNote}
                      onChange={(e) => setAdditionalNote(e.target.value)}
                    />
                  </Grid>
                </Grid>

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginTop: 4,
                  }}
                >
                  <Button variant="outlined" sx={{ marginRight: 2 }}>
                    Cancel
                  </Button>
                  <Button variant="contained" color="success" type="submit">
                    Submit
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </form>
        </div>
      </Box>
    </RouteLayout>
  );
};

export default CreateBookingsA;
